const React = require('react');

const Columns = require('../layout/Columns.jsx');
const Component = require('./Component.jsx');
const Item = require('./Item.jsx');
const _TypeConfig = require('./TypeConfig.jsx');

function withItemContentHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleComponentType = this.handleComponentType.bind(this);
            this.handleContentData = this.handleContentData.bind(this);
        }

        handleComponentType(type) {
            if (this.props.onComponentType) {
                const Component = this.props.onComponentType(type);
                if (Component) {
                    return Component;
                }
            }
            switch (type) {
                case 'itemAlternateDimensions':
                    return Item.AlternateDimensions.Component;
                case 'itemArtist':
                    return Item.Artist.Component;
                case 'itemCustomMeta':
                    return Item.CustomMeta.Component;
                case 'itemDimensions':
                    return Item.Dimensions.Component;
                case 'itemDisplayPrice':
                    return Item.DisplayPrice.Component;
                case 'itemEdition':
                    return Item.Edition.Component;
                case 'itemFramed':
                    return Item.Framed.Component;
                case 'itemImage':
                    return Item.Image.Component;
                case 'itemLocation':
                    return Item.Location.Component;
                case 'itemMedium':
                    return Item.Medium.Component;
                case 'itemNumber':
                    return Item.Number.Component;
                case 'itemPrice':
                    return Item.Price.Component;
                case 'itemSKU':
                    return Item.SKU.Component;
                case 'itemTitle':
                    return Item.Title.Component;
                default:
                    return null;
            }
        }

        handleContentData() {
            const component = this;
            const items = component.props.items || [];
            let contentData = [];
            if (items.length > 0) {
                if (component.props.builder) {
                    contentData.push(items[0]);
                } else {
                    contentData = items;
                }
            }
            return contentData;
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    onItemComponentType={this.handleComponentType}
                    onItemContentData={this.handleContentData} />
            );
        }
    }
}

class _ListContainer extends React.Component {
    constructor(props) {
        super(props);

        this.containerForItem = this.containerForItem.bind(this);
    }

    containerForItem(key, componentData) {
        let className = 'pageBreakInsideAvoid';
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        return (
            <Columns.V1.Component
                key={key}
                {...this.props}
                className={className}
                componentData={componentData}
                dataType="container"
                renderHeader={false}
                typeHandler={this.props.onItemComponentType} />
        );
    }

    render() {
        const component = this;
        const contentData = component.props.onItemContentData();
        const content = [];
        contentData.forEach(function (d, i) {
            content.push(component.containerForItem(i, [{ index: i, itemData: d }]));
        });
        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        );
    }
}
const ListContainer = Component.withBlockComponentHandler(withItemContentHandler(_ListContainer));

class _PageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.containerForItem = this.containerForItem.bind(this);
    }

    containerForItem(pageIndex, itemIndex, componentData, pageHeader, insertPageBreak) {
        const content = (
            <Columns.V1.Component
                key={pageIndex}
                {...this.props}
                componentData={componentData}
                dataType='container'
                renderHeader={false}
                typeHandler={this.props.onItemComponentType} />
        );
        let pageClassName;
        if (insertPageBreak || (this.props.items && itemIndex < this.props.items.length - 1)) {
            pageClassName = 'pageBreakAfterAlways';
        }
        return this.props.onPageForItem(pageIndex, content, pageHeader, pageClassName);
    }

    render() {
        const component = this;
        const contentData = component.props.onItemContentData();
        const pageHeader = component.props.onPageHeader();
        let content = [];
        if (component.props.onComponentContent) {
            content = component.props.onComponentContent(contentData, pageHeader, component.containerForItem);
        } else {
            contentData.forEach(function (d, i) {
                content.push(component.containerForItem(i, i, [{ index: i, itemData: d }], pageHeader));
            });
        }
        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        );
    }
}
const PageContainer = Component.withBlockComponentHandler(Component.withPageHandler(withItemContentHandler(_PageContainer)));

const TypeConfig = {
    panel: {
        block: function () {
            return {
                options: [
                    { name: 'col1_width', value: '100', visible: function () { return false; } }
                ]
            };
        },
        columns: function () { return [[]]; },
        style: function () { return _TypeConfig.panel.layoutStyle({}, undefined, {}); }
    }
};

module.exports = {
    List: ListContainer,
    Page: PageContainer,
    TypeConfig
};